import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const rightAlignColumns = css`
    .quantityCol,
    .mfrPriceCol,
    .discountCol,
    .blendedCostCol,
    .markupCol,
    .blendedPriceCol,
    .extCostCol,
    .extPriceCol {
      text-align: right;
    }

    .cellCol1 > div,
    .cellCol2 > div,
    .cellCol3 > div,
    .cellCol4 > div,
    .cellCol5 > div,
    .cellCol6 > div,
    .cellCol7 > div,
    .cellCol8 > div {
      justify-content: flex-end !important;
    }

    tbody[data-target=".multi-collapsetotal"] td {
      border-top: 3px solid ${theme.colors.navy["1"]};
    }

    tbody[data-target=".multi-collapsetotal"],
    tbody[data-target=".multi-collapseprofit"],
    tbody[data-target=".multi-collapsemargin"] {
      background-color: ${theme.colors.white} !important;
      border-top: none !important;
    }

    tbody[data-target=".multi-collapsetotal"] tr {
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapseprofit"] tr {
      padding-top: 4px;
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapsemargin"] tr {
      padding-top: 4px;
    }

    tbody[data-target=".multi-collapseprofit"] td,
    tbody[data-target=".multi-collapsemargin"] td {
      border: none;
    }
  `;

  const totalRow = css`
    font-weight: 700;
  `;

  return {
    page,
    rightAlignColumns,
    totalRow,
  };
};

export default useStyles;
